module.exports = __webpack_public_path__ + "img/code-architecture-diagram.8581fe7a.png";